// Form metadata for the Declare-as-coordinates dialog (T18): the form-value shape, the format
// dropdown options, and the numeric-type heuristic. Extracted from DeclareSpatialColumnFields so
// that component stays ≤200 lines. Pure data — no React.

import type { SpatialColumnDeclarationFormat } from '../../utils/spatialValueAccessor';

export type SpatialDeclareFormValues = {
  format: SpatialColumnDeclarationFormat;
  /** `lat-lng-pair` only — names the LNG column (this column is LAT). */
  lngColumn: string;
  /** `latlng-text` only. */
  axisOrder: 'lat-lng' | 'lng-lat';
};

export const FORMAT_OPTIONS: { value: SpatialColumnDeclarationFormat; label: string; hint: string }[] = [
  {
    value: 'lat-lng-pair',
    label: 'Latitude / longitude pair',
    hint: 'This column is latitude; pick the longitude column below.',
  },
  { value: 'wkt', label: 'WKT text', hint: 'Well-Known Text, e.g. POINT(21.0122 52.2297).' },
  { value: 'geojson', label: 'GeoJSON', hint: 'A GeoJSON geometry object, e.g. {"type":"Point",…}.' },
  {
    value: 'latlng-text',
    label: 'Lat/lng in one text column',
    hint: 'A single column holding e.g. "52.2297, 21.0122"; pick the axis order.',
  },
];

const NUMERIC_HINT = /int|real|float|double|numeric|decimal|number/i;
export const isNumericLike = (dataType?: string) => !!dataType && NUMERIC_HINT.test(dataType);
